import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Dialog, DialogContent, DialogTitle,
  IconButton,
  Link, List, ListItem, ListItemAvatar, ListItemText,
  Typography,
  withStyles
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import StoreIcon from '@material-ui/icons/Store';
import StyleableSection from "../../components/StyleableSection";
import {FormattedMessage} from "react-intl";

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%'
  },
  logo: {
    marginRight: theme.spacing(1)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

BusinessBanner.propTypes = {
  businessName: PropTypes.string,
  businessLogoUrl: PropTypes.string,
  locations: PropTypes.array,
  checkoutSettings: PropTypes.object.isRequired,
  classes: PropTypes.object
};

function BusinessBanner({
                          locations,
                          checkoutSettings,
                                  classes
                                }) {

  const [locationsDialogOpen, setLocationsDialogOpen] = useState(false);

  const logoUrl = checkoutSettings.banner.businessLogoUrl;
  const logoWidth = checkoutSettings.banner.businessLogoWidth;
  const locationsDisabled = checkoutSettings.banner.locationsDisabled;

  function handleViewLocationsClick() {
    setLocationsDialogOpen(true);
  }

  function renderLocations() {
    if (!locations || locations.length === 0) {
      return;
    }
    else if (locations.length === 1) {
      const location = locations[0];
      return (
        <Typography variant="body1">
          {location.address.formatted}
        </Typography>
      );
    } else if (locations.length > 1) {
      return (
        <>
        <Typography variant="body1">
          <Link href="#" onClick={handleViewLocationsClick}>
            <FormattedMessage id={'button.view-locations'}/>
          </Link>
        </Typography>
          <Dialog
            open={locationsDialogOpen}
            onClose={() => setLocationsDialogOpen(false)}>
            <DialogTitle id="locations">
              <Typography variant="h3">
                <FormattedMessage id={"header.locations"}/>
              </Typography>
              <IconButton aria-label="close" className={classes.closeButton} onClick={() => setLocationsDialogOpen(false)}>
                <CloseIcon/>
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <List>
                {locations.map((location, locationIndex) => {
                  return (
                    <ListItem key={location.id}>
                      <ListItemAvatar>
                        <Avatar>
                          <StoreIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText primary={location.name} secondary={location.address.formatted} />
                    </ListItem>
                  );}
                )}
              </List>
            </DialogContent>
          </Dialog>
        </>
      );
    }
    return;
  }

  return (
    <StyleableSection className={classes.container} section={checkoutSettings.banner}>
      {logoUrl &&
      <img className={classes.logo} alt="business logo" src={logoUrl} width={logoWidth}/>
      }
      <Typography variant={'h6'}>
        {checkoutSettings.banner.businessName}
      </Typography>
      {!locationsDisabled && renderLocations()}
    </StyleableSection>

  );
}

export default withStyles(styles)(BusinessBanner);
